import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	padding: 1rem;

	> div {
		> p {
			color: ${color.interface.darkgray};
			font-size: 1.4rem;
		}
	}
`;

export const icon = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;

	> svg {
		font-size: 20px;
		width: fit-content;
		color: ${color.interface.darkgray};
	}
`;
